import { IModel, Model } from "@common/models";
import { makeObservable, observable } from "mobx";

export interface IDiagnosisStatusModel extends IModel {
    diagnosisStatusId: number;
    name: string;
}

export class DiagnosisStatusModel extends Model implements Record<keyof IDiagnosisStatusModel, any>  {
    @observable diagnosisStatusId: number; 
    @observable name: string;
    constructor(params: IDiagnosisStatusModel) {
        super(params);
        this.diagnosisStatusId = _.defaultTo(params?.diagnosisStatusId, 0);
        this.name = _.defaultTo(params?.name, "");
        makeObservable(this);
    }
}
